/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SupplyingPackingPlantBaseContract} from '../../../api/ms-partnumberchanges/contracts/supplying-packing-plant-base.contract';
import {SupplyingPackingPlantBaseModel} from './supplying-packing-plant-base.model';


export class SupplyingPackingPlantBaseMapper {

    static fromSupplyingPackingPlantBaseContractArray(input: SupplyingPackingPlantBaseContract[]): SupplyingPackingPlantBaseModel[] {
        return input?.map((element) => SupplyingPackingPlantBaseMapper.fromSupplyingPackingPlantBaseContract(element));
    }

    static fromSupplyingPackingPlantBaseContract(input: SupplyingPackingPlantBaseContract): SupplyingPackingPlantBaseModel {
        let output: SupplyingPackingPlantBaseModel;
        if (input != null) {
            output = {
                name: input.name,
                code: input.code,
                active: input.active
            };
        }
        return output;
    }
}
